/* eslint-disable */
export default {
  status: 'Estado',
  acceptQueueCalls: 'Aceitar chamadas da fila de chamadas',
  callQueueDisabledReason:
    'Esta definição é gerida pelo administrador da empresa.',
  callQueueManagement: 'Gerir filas',
} as const;

// @key: @#@"status"@#@ @source: @#@"Status"@#@
// @key: @#@"acceptQueueCalls"@#@ @source: @#@"Accept call queue calls"@#@
// @key: @#@"callQueueDisabledReason"@#@ @source: @#@"This setting is managed by your company administrator."@#@
// @key: @#@"callQueueManagement"@#@ @source: @#@"Manage queues"@#@
